import React, { useEffect, useRef } from "react";
import c3 from "c3";

import "c3/c3.min.css";
import PieChart from "./PieChart";

const Chart = (props) => {
  const nodeRef = useRef();

  useEffect(() => {
    // Wait for DOM element to be created
    // ... so we can acquire reference
    if (props.data.type !== "pie" || props.data.type !== "donut") {
      const _handle = c3.generate({
        ...props,
        bindto: nodeRef.current,
      });
    }
  }, [props]);

  return (
    <>
      {props?.data?.type === "pie" || props?.data?.type === "donut" ? (
        <PieChart props={props} />
      ) : (
        <div ref={nodeRef}></div>
      )}
    </>
  );
};

export default Chart;
